{
  "instances": {
    "configprops": {
      "label": "Propriedades de Configuração",

      "no_properties_set": "Nenhuma propriedade definida"
    }
  }
}
